import SummaryList from '@components/SummaryList/SummaryList';

SummaryList();
